import { render } from "./mainSlider.vue?vue&type=template&id=3bd785bc&scoped=true"
import script from "./mainSlider.vue?vue&type=script&lang=js"
export * from "./mainSlider.vue?vue&type=script&lang=js"

import "./mainSlider.vue?vue&type=style&index=0&id=3bd785bc&scoped=true&lang=css"

import exportComponent from "C:\\onetap\\onetap\\frontend\\onetapuser\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd785bc"]])

export default __exports__